// SafeLens ロゴ(設計書 DESIGN_SYSTEM.md ロゴ表示)

interface LogoProps {
  size?: 'sm' | 'md';
}

export function Logo({ size = 'md' }: LogoProps) {
  const px = size === 'sm' ? 22 : 28;
  const fontSize = size === 'sm' ? 14 : 16;
  const inner = size === 'sm' ? 9 : 11;
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
      <div
        style={{
          width: px,
          height: px,
          background: 'var(--gradient-cta)',
          borderRadius: '7px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span style={{ color: 'white', fontWeight: 500, fontSize: inner }}>SL</span>
      </div>
      <span style={{ fontSize, fontWeight: 500, color: 'var(--color-text-primary)' }}>
        SafeLens
      </span>
    </div>
  );
}
